module.exports = __webpack_public_path__ + "img/camera.c12ffe14.svg";